import { useEffect, useState } from 'react'
import './index.less'
import RightPanelTab from '@/global/components/right-panel-tab'
import { MonitorObject } from '@/global/interface/monitor-object/monitor-object'
import MonitorParameterWarningSetting from './param'

interface Iprops {
    monitorObject: MonitorObject
}

export default function MonitorObjectInfoPanel(props: Iprops) {
    const [item, setItem] = useState<MonitorObject>(); // 监测对象
    const [activeTab, setActiveTab] = useState<'info' | 'setting'>("info") // 当前激活栏

    useEffect(() => {
        setItem(props.monitorObject);
    }, [props.monitorObject])

    return (
        <div className="monitor-object-info-panel">
            <div className="tab-area">
                <RightPanelTab
                    dataList={[
                        { label: `${item?.name || '信息'}`, value: "info" },
                        { label: "设置", value: "setting" },
                    ]}
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                />
            </div>
            <div className="main">
                {activeTab == "info" && <div className="info">
                    <div className="item">
                        <div className="label">建筑功能</div>
                        <div className="text-value">{item?.archiFunction}</div>
                    </div>
                    <div className="item">
                        <div className="label">材料类别</div>
                        <div className="text-value">{item?.materialType}</div>
                    </div>
                    <div className="item">
                        <div className="label">材料牌号</div>
                        <div className="text-value">{item?.materialGrade}</div>
                    </div>
                </div>}
                {activeTab == 'setting' && <div className="setting">
                    <div className="param">
                        <div className="name header"></div>
                        <div className="cell header">二级预警值</div>
                        <div className="cell sec header">三级预警值</div>
                        <div className="cell third header">四级预警值</div>
                    </div>
                    {(item?.rootMonitorParameters || []).map((param, idx) => (
                        <MonitorParameterWarningSetting
                            param={param}
                            onUpdateParam={(id: number, data) => {
                                let newParam = { ...param, ...data };
                                item.rootMonitorParameters.splice(idx, 1, newParam);
                                setItem({ ...item });
                            }}
                        />
                    ))}
                </div>}
            </div>
        </div>
    )
}